/* src/app/shared/components/tabs/tabs.component.scss */
/*# sourceMappingURL=tabs.component.css.map */
